<template>
  <div class="bg-gray-50 h-dvh">
    <div class="h-full">
      <router-view />
    </div>
    <van-tabbar :model-value="activeRoute" @change="tabsChange">
      <van-tabbar-item name="home" icon="home-o">Home</van-tabbar-item>
      <van-tabbar-item name="sermons" icon="audio">Mesaje</van-tabbar-item>
      <van-tabbar-item name="catechism" icon="list-switch">Catehism</van-tabbar-item>
      <van-tabbar-item name="settings" icon="setting-o">Optiuni</van-tabbar-item>
    </van-tabbar>
    <pwa-install
      manifest-url="/manifest.webmanifest"
      name="Gratia Dei"
      description="Aplicatia bisericii Gratia Dei"
      icon="/icon.svg"
      install-description="Poți avea aplicația instalată pe propriul dispozitiv. Pentru aceasta te rugăm să apeși butonul Install."
      >></pwa-install
    >
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useCollectionsStore } from './stores/collectionsStore'
import { storeToRefs } from 'pinia'

const router = useRouter()
const route = useRoute()
const collectionsStore = useCollectionsStore()
const { activeCollectionName } = storeToRefs(collectionsStore)

const activeRoute = computed(() => route.name as string)

const tabsChange = (index: string) => {
  router.push({ name: index })
}

onMounted(async () => {
  if (activeCollectionName.value) {
    collectionsStore.loadCollection(activeCollectionName.value)
  }
  await import('@khmyznikov/pwa-install')
})
</script>

<style lang="css">
:root {
  --van-primary-color: var(--color-amber-800);
}
</style>
